import { AdditiveBorderType, ImageClass } from "../../Types/UiKitsType";

export const borderStyleSubTitle = [
    {
        text: "Use the different styles of borders like:",
        code: 'border radius/border-color/border-width'
    },
    {
        text: '. Use of any components.'
    }
];

export const backgroundColorSubTitle = [
    {
        text: 'Use the ',
        code: '.bg-* '
    },
    {
        text: 'and ',
        code: '.alert-light-*'
    },
    {
        text: 'colors in Oliva theme.Use of any components.'
    }
];

export const borderColorSubTitle = [
    {
        text: "Use the ",
        code: '.b-*/.b-t-*/.b-b-*/.b-l-*/.b-r-*'
    },
    {
        text: 'class for borders.'
    }
];

export const imageSubTitle = [
    {
        text: "Use the width and height of images class like: ",
        code: '.img-*'
    },
    {
        text: "and",
        code: '.img-h-*'
    },
    {
        text: '.'
    }
];

export const fontStyleSubTitle = [
    {
        text: "Use the font-style like: ",
        code: ' .f-s-* [normal/italic/oblique/initial/inherit]'
    },
    {
        text: '.'
    }
];

export const fontWeightSubTitle = [
    {
        text: "Use the font-weight classes like: ",
        code: '.f-w-* [100/300/400/600/700/900]'
    }
]

export const textColorSubTitle = [
    {
        text: "Use the text color for ",
        code: '.font-*'
    },
    {
        text: " class.",
    }
];

export const fontSizeSubTitle = [
    {
        text: "Use the font-size for ",
        code: '.f-* [14/16/18/20/22/24/26/28/30/32/34/36/38/40]'
    },
    {
        text: '.'
    }
];

export const bordersAndDisplaySubTitle = [
    {
        text: "Use border utilities to add or remove an element's borders.",
    }
]

export const customBorderData: AdditiveBorderType[] = [
    {
        class: 'b-r-0',
        text: '.b-r-0'
    },
    {
        class: 'b-r-1',
        text: '.b-r-1'
    },
    {
        class: 'b-r-2',
        text: '.b-r-2'
    },
    {
        class: 'b-r-3',
        text: '.b-r-3'
    },
    {
        class: 'b-r-4',
        text: '.b-r-4'
    },
    {
        class: 'b-r-5',
        text: '.b-r-5'
    },
    {
        class: 'b-r-6',
        text: '.b-r-6'
    },
    {
        class: 'b-r-7',
        text: '.b-r-7'
    },
    {
        class: 'b-r-8',
        text: '.b-r-8'
    },
    {
        class: 'b-r-9',
        text: '.b-r-9'
    },
    {
        class: 'b-r-10',
        text: '.b-r-10'
    }
];

export const borderColorData: AdditiveBorderType[] = [
    {
        class: 'border-primary',
        text: '.border-primary'
    },
    {
        class: 'border-secondary',
        text: '.border-secondary'
    },
    {
        class: 'border-success',
        text: '.border-success'
    },
    {
        class: 'border-danger',
        text: '.border-danger'
    },
    {
        class: 'border-warning',
        text: '.border-warning'
    },
    {
        class: 'border-info',
        text: '.border-info'
    },
    {
        class: 'border-dark',
        text: '.border-dark'
    }
];

export const borderWidthData: AdditiveBorderType[] = [
    {
        class: 'border-1',
        text: '.border-1'
    },
    {
        class: 'border-2',
        text: '.border-2'
    },
    {
        class: 'border-3',
        text: '.border-3'
    },
    {
        class: 'border-4',
        text: '.border-4'
    },
    {
        class: 'border-5',
        text: '.border-5'
    },
    {
        class: 'border-6',
        text: '.border-6'
    },
    {
        class: 'border-7',
        text: '.border-7'
    },
    {
        class: 'border-8',
        text: '.border-8'
    },
    {
        class: 'border-9',
        text: '.border-9'
    },
    {
        class: 'border-10',
        text: '.border-10'
    }
]

export const textColorData: AdditiveBorderType[] = [
    {
        class: 'txt-primary',
        text: '.txt-primary'
    },
    {
        class: 'txt-secondary',
        text: '.txt-secondary'
    },
    {
        class: 'txt-success',
        text: '.txt-success'
    },
    {
        class: 'txt-danger',
        text: '.txt-danger'
    },
    {
        class: 'txt-warning',
        text: '.txt-warning'
    },
    {
        class: 'txt-info',
        text: '.txt-info'
    },
    {
        class: 'txt-dark',
        text: '.txt-dark'
    },
    {
        class: 'txt-light bg-dark',
        text: '.txt-light'
    }
];

export const additiveBorderData: AdditiveBorderType[] = [
    {
        class: 'border',
        text: '.border'
    },
    {
        class: 'border-top',
        text: '.border-top'
    },
    {
        class: 'border-bottom',
        text: '.border-bottom'
    },
    {
        class: 'border-start',
        text: '.border-start'
    },
    {
        class: 'border-end',
        text: '.border-end'
    }
]

export const subtractiveData: AdditiveBorderType[] = [
    {
        class: 'border-0',
        text: '.border-0'
    },
    {
        class: 'border-top-0',
        text: '.border-top-0'
    },
    {
        class: 'border-end-0',
        text: '.border-end-0'
    },
    {
        class: 'border-bottom-0',
        text: '.border-bottom-0'
    },
    {
        class: 'border-start-0',
        text: '.border-start-0'
    }
]

export const additiveRadiusData: AdditiveBorderType[] = [
    {
        class: 'rounded',
        text: '.rounded'
    },
    {
        class: 'rounded-top',
        text: '.rounded-top'
    },
    {
        class: 'rounded-end',
        text: '.rounded-end'
    },
    {
        class: 'rounded-bottom',
        text: '.rounded-bottom'
    },
    {
        class: 'rounded-start',
        text: '.rounded-start'
    },
    {
        class: 'rounded-pill',
        text: '.rounded-pill'
    },
    {
        class: 'rounded-circle',
        text: '.rounded-circle'
    },
    {
        class: 'rounded-0',
        text: '.rounded-0'
    }
]

export const darkBackgroundData: AdditiveBorderType[] = [
    {
        class: 'bg-primary',
        text: '.bg-primary'
    },
    {
        class: 'bg-secondary',
        text: '.bg-secondary'
    },
    {
        class: 'bg-success',
        text: '.bg-success'
    },
    {
        class: 'bg-danger',
        text: '.bg-danger'
    },
    {
        class: 'bg-warning',
        text: '.bg-warning'
    },
    {
        class: 'bg-info',
        text: '.bg-info'
    },
    {
        class: 'bg-dark',
        text: '.bg-dark'
    },
    {
        class: 'bg-light',
        text: '.bg-light'
    }
]

export const lightBackgroundData: AdditiveBorderType[] = [
    {
        class: 'alert-light-primary',
        text: '.alert-light-primary'
    },
    {
        class: 'alert-light-secondary',
        text: '.alert-light-secondary'
    },
    {
        class: 'alert-light-success',
        text: '.alert-light-success'
    },
    {
        class: 'alert-light-danger',
        text: '.alert-light-danger'
    },
    {
        class: 'alert-light-warning',
        text: '.alert-light-warning'
    },
    {
        class: 'alert-light-info',
        text: '.alert-light-info'
    },
    {
        class: 'alert-light-dark',
        text: '.alert-light-dark'
    },
    {
        class: 'alert-light-light',
        text: '.alert-light-light'
    }
]

export const borderSideColorData: AdditiveBorderType[] = [
    {
        class: 'b-primary',
        text: '.b-primary'
    },
    {
        class: 'b-t-primary',
        text: '.b-t-primary'
    },
    {
        class: 'b-b-primary',
        text: '.b-b-primary'
    },
    {
        class: 'b-l-primary',
        text: '.b-l-primary'
    },
    {
        class: 'b-r-primary',
        text: '.b-r-primary'
    },
    {
        class: 'b-secondary',
        text: '.b-secondary'
    },
    {
        class: 'b-t-secondary',
        text: '.b-t-secondary'
    },
    {
        class: 'b-b-secondary',
        text: '.b-b-secondary'
    },
    {
        class: 'b-l-secondary',
        text: '.b-l-secondary'
    },
    {
        class: 'b-r-secondary',
        text: '.b-r-secondary'
    },
    {
        class: 'b-success',
        text: '.b-success'
    },
    {
        class: 'b-t-success',
        text: '.b-t-success'
    },
    {
        class: 'b-b-success',
        text: '.b-b-success'
    },
    {
        class: 'b-l-success',
        text: '.b-l-success'
    },
    {
        class: 'b-r-success',
        text: '.b-r-success'
    },
    {
        class: 'b-danger',
        text: '.b-danger'
    },
    {
        class: 'b-t-danger',
        text: '.b-t-danger'
    },
    {
        class: 'b-b-danger',
        text: '.b-b-danger'
    },
    {
        class: 'b-l-danger',
        text: '.b-l-danger'
    },
    {
        class: 'b-r-danger',
        text: '.b-r-danger'
    },
    {
        class: 'b-warning',
        text: '.b-warning'
    },
    {
        class: 'b-t-warning',
        text: '.b-t-warning'
    },
    {
        class: 'b-b-warning',
        text: '.b-b-warning'
    },
    {
        class: 'b-l-warning',
        text: '.b-l-warning'
    },
    {
        class: 'b-r-warning',
        text: '.b-r-warning'
    },
    {
        class: 'b-info',
        text: '.b-info'
    },
    {
        class: 'b-t-info',
        text: '.b-t-info'
    },
    {
        class: 'b-b-info',
        text: '.b-b-info'
    },
    {
        class: 'b-l-info',
        text: '.b-l-info'
    },
    {
        class: 'b-r-info',
        text: '.b-r-info'
    },
    {
        class: 'b-dark',
        text: '.b-dark'
    },
    {
        class: 'b-t-dark',
        text: '.b-t-dark'
    },
    {
        class: 'b-b-dark',
        text: '.b-b-dark'
    },
    {
        class: 'b-l-dark',
        text: '.b-l-dark'
    },
    {
        class: 'b-r-dark',
        text: '.b-r-dark'
    },
    {
        class: 'b-light',
        text: '.b-light'
    },
    {
        class: 'b-t-light',
        text: '.b-t-light'
    },
    {
        class: 'b-b-light',
        text: '.b-b-light'
    },
    {
        class: 'b-l-light',
        text: '.b-l-light'
    },
    {
        class: 'b-r-light',
        text: '.b-r-light'
    },
]

export const imageData: ImageClass[] = [
    {
        class: 'img-30 img-h-30',
    },
    {
        class: 'img-40 img-h-40',
    },
    {
        class: 'img-50 img-h-50',
    },
    {
        class: 'img-60 img-h-60',
    },
    {
        class: 'img-70 img-h-70',
    },
    {
        class: 'img-80 img-h-80',
    },
    {
        class: 'img-90 img-h-90',
    },
    {
        class: 'img-100 img-h-100'
    }

]
export const fontStyleData: AdditiveBorderType[] = [
    {
        class: 'f-s-normal',
        text: 'This is a ',
        text2: ' font-style'
    },
    {
        class: 'f-s-italic',
        text: 'This is a ',
        text2: ' font-style'
    },
    {
        class: 'f-s-oblique',
        text: 'This is a ',
        text2: ' font-style'
    },
    {
        class: 'f-s-initial',
        text: 'This is a ',
        text2: ' font-style'
    },
    {
        class: 'f-s-inherit',
        text: 'This is a ',
        text2: ' font-style'
    }
]

export const fontWeightData: AdditiveBorderType[] = [
    {
        class: 'f-w-100',
        text: 'You can set light font weight heading .f-w-100'
    },
    {
        class: 'f-w-300',
        text: 'You can set light font weight heading .f-w-300'
    },
    {
        class: 'f-w-400',
        text: 'You can set light font weight heading .f-w-400'
    },
    {
        class: 'f-w-600',
        text: 'You can set bolder font weight heading .f-w-600'
    },
    {
        class: 'f-w-700',
        text: 'You can set bold font weight heading .f-w-700'
    },
    {
        class: 'f-w-900',
        text: 'You can set bold font weight heading .f-w-900'
    }
]

export const textColorsData: AdditiveBorderType[] = [
    {
        class: 'font-primary',
        text: 'This is a ',
        text2: 'text used class as .font-primary'
    },
    {
        class: 'font-secondary',
        text: 'This is a ',
        text2: 'text used class as .font-secondary'
    },
    {
        class: 'font-success',
        text2: 'text used class as .font-success',
        text: 'This is a '
    },
    {
        class: 'font-danger',
        text2: 'text used class as .font-danger',
        text: 'This is a '
    },
    {
        class: 'font-warning',
        text2: 'text used class as .font-warning',
        text: 'This is a '
    },
    {
        class: 'font-info',
        text2: 'text used class as .font-info',
        text: 'This is a '
    },
    {
        class: 'font-dark',
        text2: 'text used class as .font-dark',
        text: 'This is a '
    }
]

export const fontSizeData: AdditiveBorderType[] = [
    {
        class: 'f-14',
        text: 'Font-size .f-14'
    },
    {
        class: 'f-16',
        text: 'Font-size .f-16'
    },
    {
        class: 'f-18',
        text: 'Font-size .f-18'
    },
    {
        class: 'f-20',
        text: 'Font-size .f-20'
    },
    {
        class: 'f-22',
        text: 'Font-size .f-22'
    },
    {
        class: 'f-24',
        text: 'Font-size .f-24'
    },
    {
        class: 'f-26',
        text: 'Font-size .f-26'
    },
    {
        class: 'f-28',
        text: 'Font-size .f-28'
    },
    {
        class: 'f-30',
        text: 'Font-size .f-30'
    },
    {
        class: 'f-32',
        text: 'Font-size .f-32'
    },
    {
        class: 'f-34',
        text: 'Font-size .f-34'
    },
    {
        class: 'f-36',
        text: 'Font-size .f-36'
    },
    {
        class: 'f-38',
        text: 'Font-size .f-38'
    },
    {
        class: 'f-40',
        text: 'Font-size .f-40'
    }
]